import { withLazyFallback } from 'lib/hoc/withLazyFallback';

const NotFound = withLazyFallback(() => import('components/NotFound'));

const AdminUsersTable = withLazyFallback(
  () => import('components/admin/pages/Users/AdminUsersTable')
);
const AdminUserLogs = withLazyFallback(() => import('components/admin/pages/Users/Logs'));

const AdminUserOverview = withLazyFallback(() => import('components/admin/pages/Users/Overview'));
const AdminUserSessions = withLazyFallback(() => import('components/admin/pages/Users/Sessions'));
const AdminUserUser = withLazyFallback(() => import('components/admin/pages/Users/User'));

const ADMIN_USERS = [
  {
    path: 'users',
    element: <AdminUsersTable />,
    children: [
      {
        path: ':id',
        element: <AdminUserUser />,
        children: [
          {
            path: '',
            element: <AdminUserOverview />
          },
          {
            path: 'logs',
            element: <AdminUserLogs />
          },
          {
            path: 'sessions',
            element: <AdminUserSessions />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];
export default ADMIN_USERS;
